import Component from './ProfileHeroMobile';
import Container from './ProfileHeroMobile.container';

export default Container(Component);
